import { inject } from "@angular/core";
import { CanActivateFn } from "@angular/router";
import { AuthStore } from "../+state/auth";

export const ThemeGuard: CanActivateFn = () => {
  const authStore = inject(AuthStore);

  if (authStore.theme()) {
    return true;
  }

  return false;
};
